import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  standalone: true,
  selector: 'crm-user-and-group-multi-select',
  templateUrl: './user-and-group-multi-select.component.html',
  imports: [CommonModule, MultiSelectModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAndGroupMultiSelectComponent implements OnChanges {
  @Input() public users: UserFindInterface[] = [];
  @Input() public userGroups: UserGroupFindInterface[] = [];

  @Input() public selectedEntities: Array<any> = [];
  @Output() public selectedEntitiesChange = new EventEmitter<Array<any>>();

  @Input() public disabled = false;
  @Input() public rememberSelected = false;
  @Input() public styleClass = '';
  @Input() public class = '';
  @Input() public appendTo: any;

  private originalSelected: Array<any> = [];
  public _selected: any[];

  public auditors: { label: string; items: any[] }[];

  public constructor(private readonly cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedEntities) {
      setTimeout(() => this.setSelected(), 400);
    }

    // if (changes.users?.currentValue) {
    //   this.users = this.users.map((user) => {
    //     user.name = user.profile?.name;
    //     return user;
    //   });
    // }

    if (changes.users || changes.userGroups) {
      this.users.sort((user1, user2) => {
        if (user1.name > user1.name) {
          return 1;
        } else if (user1.name < user2.name) {
          return -1;
        }
        return 0;
      });
      this.userGroups.sort((userGroup1, userGroup2) => {
        if (userGroup1.name > userGroup2.name) {
          return 1;
        } else if (userGroup1.name < userGroup2.name) {
          return -1;
        }
        return 0;
      });

      this.auditors = [
        {
          label: 'Пользователи',
          items: this.users
        },
        {
          label: 'Группы',
          items: this.userGroups
        }
      ];
    }
  }

  public setSelected() {
    this.originalSelected = this.selectedEntities ? [...this.selectedEntities] : [];
    this._selected = this.selectedEntities ? this.selectedEntities.map((auditor) => auditor.user || auditor.group) : [];
    this.cdRef.markForCheck();
  }

  public onSelectedChange(items: any[]) {
    const auditors = items.map((item) => {
      const plainItem = item.profile ? <any>{ user: item } : <any>{ group: item };
      if (this.rememberSelected) {
        const currentAuditor = this.originalSelected.find((auditor) =>
          auditor.user ? auditor.user.id === item.id : auditor.group?.id === item.id
        );
        return currentAuditor || plainItem;
      }
      return plainItem;
    });
    this.selectedEntities = auditors;
    this.selectedEntitiesChange.emit(auditors);
  }
}
